import { useState, useEffect } from 'react';
import { useAuthenticatedApi } from './useAuthenticatedApi';
import { useAuth } from '../contexts/AuthContext';

interface TrialEligibilityStatus {
  trialEligible: boolean | null;
  loading: boolean;
  error: string | null;
}

export const useTrialEligibility = () => {
  const api = useAuthenticatedApi();
  const { isAuthenticated, isLoading } = useAuth();
  const [status, setStatus] = useState<TrialEligibilityStatus>({
    trialEligible: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let isCancelled = false;

    const checkEligibility = async () => {
      if (isLoading || !isAuthenticated || !api) {
        setStatus((prev) => ({ ...prev, loading: false }));
        return;
      }

      try {
        const response = await api.get<{ trial_eligible: boolean }>(
          '/organizations/trial-eligibility'
        );

        if (!isCancelled) {
          setStatus({
            trialEligible: response.trial_eligible,
            loading: false,
            error: null,
          });
        }
      } catch (err: any) {
        if (!isCancelled) {
          setStatus({
            trialEligible: null,
            loading: false,
            error: err.message || 'Failed to check trial eligibility',
          });
        }
      }
    };

    checkEligibility();
    return () => {
      isCancelled = true;
    };
  }, [api, isAuthenticated, isLoading]);

  return status;
};
